<template>
    <div>
        <v-textarea dense label="Question" outlined v-model="question" :value="field.question"  @keyup="emitChange()"></v-textarea>
        <v-radio-group v-model="radiogroup">
            <v-radio label="Yes" value="yes"></v-radio>
            <v-radio label="No" value="yes"></v-radio>
        </v-radio-group>
    </div>
</template>

<script>
  export default {
    props:['field'],
    components: {},
    name: "YesNo",
    data() {
      return {
        radiogroup: undefined,
        question:undefined,
        answer:undefined,
        test:[ { "type": "YesNo", "question": "this is the first question", "key": 1588544873956 }, { "type": "MultipleChoice", "question": "this is the next question", "answer": { "a": "this is answer 1", "b": "this is answer 2", "c": "answer c", "d": "answer d" }, "key": 1588544883360 }, { "type": "YesNo", "question": "This is the second Yes/No Question", "key": 1588544945431 } ]
      }
    },
    mounted() {
    },
    methods: {
      emitChange(){
        this.$emit('formData',{question: this.question, answer: this.answer})
      }
    }
  }
</script>

<style scoped>

</style>